import React from "react";

export default function MainDisplay({ selectedFile, editedContent, selectedImage }) {
  return (
    <div className="main-display border p-3 mt-3">
      {selectedFile ? (
        <>
          <h4>Currently Opened: {selectedFile.name}</h4>
          {selectedFile.type.includes("image") && selectedImage ? (
            <img src={selectedImage} alt="Selected" style={{ width: "400px", marginTop: "10px" }} />
          ) : (
            <pre>{editedContent || "File Content Here"}</pre>
          )}
        </>
      ) : (
        <p>No file selected.</p>
      )}
    </div>
  );
}
